export const MetaMap = [{
    reg: /^\/$/,
    rules: {
        'WWW': [{ name: 'viewport', content: 'width=device-width,initial-scale=1,maximum-scale=1.0,user-scalable=0' }],
        'notWWW': [{ name: 'viewport', content: 'width=device-width,initial-scale=1,maximum-scale=1.0,user-scalable=0' }]
    }
}, {
    reg: /^\/map\/?$/,
    rules: {
        'WWW': [{ name: 'viewport', content: 'width=device-width,initial-scale=1,maximum-scale=1.0,user-scalable=0' }],
        'notWWW': [{ name: 'viewport', content: 'width=device-width,initial-scale=1,maximum-scale=1.0,user-scalable=0' }]
    }
}, {
    reg: /^\/download-app\/?$/,
    rules: {
        'WWW': [{ name: 'viewport', content: 'width=device-width,initial-scale=1,maximum-scale=1.0,user-scalable=0' }],
        'notWWW': [{ name: 'viewport', content: 'width=device-width,initial-scale=1,maximum-scale=1.0,user-scalable=0' }]
    }
}, {
    reg: /^\/about-us\/?$/,
    rules: {
        'WWW': [{ name: 'viewport', content: 'width=device-width,initial-scale=1,maximum-scale=1.0,user-scalable=0' }],
        'notWWW': [{ name: 'viewport', content: 'width=device-width,initial-scale=1,maximum-scale=1.0,user-scalable=0' }]
    }
}, {
    reg: /^\/seller-guide\/?$/,
    rules: {
        'WWW': [{ name: 'viewport', content: 'width=device-width,initial-scale=1,maximum-scale=1.0,user-scalable=0' }],
        'notWWW': [{ name: 'viewport', content: 'width=device-width,initial-scale=1,maximum-scale=1.0,user-scalable=0' }]
    }
}, {
    reg: /^\/buyer-guide\/?$/,
    rules: {
        'WWW': [{ name: 'viewport', content: 'width=device-width,initial-scale=1,maximum-scale=1.0,user-scalable=0' }],
        'notWWW': [{ name: 'viewport', content: 'width=device-width,initial-scale=1,maximum-scale=1.0,user-scalable=0' }]
    }
}, {
    reg: /^\/news-list\/[^\/]+\/?$/,
    rules: {
        'WWW': [{ name: 'viewport', content: 'width=device-width,initial-scale=1,maximum-scale=1.0,user-scalable=0' }],
        'notWWW': [{ name: 'viewport', content: 'width=device-width,initial-scale=1,maximum-scale=1.0,user-scalable=0' }]
    }
}, {
    reg: /^\/news-detail\/[^\/]+\/[^\/]+\/?$/,
    rules: {
        'WWW': [{ name: 'viewport', content: 'width=device-width,initial-scale=1,maximum-scale=1.0,user-scalable=0' }],
        'notWWW': [{ name: 'viewport', content: 'width=device-width,initial-scale=1,maximum-scale=1.0,user-scalable=0' }]
    }
}, {
    reg: /^\/contact-us\/?$/,
    rules: {
        'WWW': [{ name: 'viewport', content: 'width=device-width,initial-scale=1,maximum-scale=1.0,user-scalable=0' }],
        'notWWW': [{ name: 'viewport', content: 'width=device-width,initial-scale=1,maximum-scale=1.0,user-scalable=0' }]
    }
}, {
    reg: /^\/home-loan\/?$/,
    rules: {
        'WWW': [{ name: 'viewport', content: 'width=device-width,initial-scale=1,maximum-scale=1.0,user-scalable=0' }],
        'notWWW': [{ name: 'viewport', content: 'width=device-width,initial-scale=1,maximum-scale=1.0,user-scalable=0' }]
    }
}, {
    reg: /^\/home-services\/?$/,
    rules: {
        'WWW': [],
        'notWWW': [{ name: 'viewport', content: 'width=device-width,initial-scale=1,maximum-scale=1.0,user-scalable=0' }]
    }
}, {
    reg: /^\/research-suburb\/?$/,
    rules: {
        'WWW': [{ name: 'viewport', content: 'width=device-width,initial-scale=1,maximum-scale=1.0,user-scalable=0' }],
        'notWWW': [{ name: 'viewport', content: 'width=device-width,initial-scale=1,maximum-scale=1.0,user-scalable=0' }]
    }
}];
